export function createInstanceNode() {
  return {
    id: `inst_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    definitionId: null,
    name: "",
    transform: {
      position: { x: 0, y: 0, z: 0 },
      rotation: { x: 0, y: 0, z: 0 }, // degrees
    },
    parameterBindings: {},
    parameterOverrides: {},
    children: [],
  };
}